import styled, { css } from 'styled-components'

import ArrowRight from '@public/images/svg/arrow-right.svg'
import { Link } from '@ui/links/Link'

export const Arrow = styled(ArrowRight)`
  ${({ theme, $colorArrow }) => css`
    margin-left: ${theme.newSpaces.xs2}px;

    path {
      fill: ${$colorArrow || theme.newColors.dark};
    }
  `}
`

export const StyledArrowLink = styled(Link)`
  font-weight: ${({ theme }) => theme.fontWeight[7]};
  text-align: end;
  text-transform: uppercase;
  width: 100%;

  &:hover {
    text-decoration: none;
  }
`

export const Content = styled.span`
  align-items: center;
  border-bottom: 2px solid transparent;
  display: flex;
  justify-content: flex-end;
  padding-right: 38px;
  position: relative;
  transition: all 0.2s ease-out 0s;

  ${({ theme }) => theme.below.laptop`
     margin-right: 7%;
  `}

  &:hover {
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 3px;
  }
`
